import { useQuery } from '@tanstack/react-query'

import { organizationsOrganizationsRetrieveOptions } from 'src/api/main'

/**
 * The workspace's `domain_name` (its subdomain segment), used to build the
 * app-launch URL. Reuses the same cached org-retrieve query as
 * `WorkspacePageShell`, so it adds no extra request.
 */
export const useWorkspaceDomainName = (workspaceId: number): string | null => {
  const { data } = useQuery({
    ...organizationsOrganizationsRetrieveOptions({
      path: { id: workspaceId }
    }),
    enabled: Number.isFinite(workspaceId)
  })

  return data?.domain_name ?? null
}
